import { Injectable } from '@angular/core';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import {
	ISelectedSortParams,
	ISortButtonMenuItem,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/interfaces-and-types/sort-item.interfaces';
import { AuUtilsFunctions } from '@app/shared';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class CmmsSortService {
	sortColumns$: Observable<ISortButtonMenuItem[]>;
	selectedSortParams$: Observable<ISelectedSortParams>;
	clearSort$ = new Subject<void>();

	private sortColumns: ISortButtonMenuItem[] = [];
	private selectedSortParams: ISelectedSortParams = {
		sortColumn: null,
		order: 'asc',
	};

	private sortColumnsSubject = new BehaviorSubject(this.sortColumns);
	private selectedSortParamsSubject = new BehaviorSubject(this.selectedSortParams);

	constructor() {
		this.sortColumns$ = this.sortColumnsSubject.asObservable();
		this.selectedSortParams$ = this.selectedSortParamsSubject.asObservable();
	}

	createSortConfigFromColumns(
		columns: ICMMSColumn[],
		initialSortParams?: ISelectedSortParams
	): void {
		this.sortColumns = columns.reduce((filteredColumns, column) => {
			if (column.isSortable) {
				filteredColumns.push({ name: column.head, columnKey: column.key });
			}
			return filteredColumns;
		}, [] as ISortButtonMenuItem[]);

		this.sortColumns.sort((a, b) => a.name.localeCompare(b.name));

		if (initialSortParams) {
			this.selectedSortParams = initialSortParams;
			this.selectedSortParamsSubject.next(this.selectedSortParams);
		}

		this.sortColumnsSubject.next(this.sortColumns);
	}

	selectSort(option: ISortButtonMenuItem) {
		if (
			this.selectedSortParams.sortColumn !== null &&
			AuUtilsFunctions.isEqual(this.selectedSortParams.sortColumn, option)
		) {
			const order = this.selectedSortParams.order;
			this.selectedSortParams.order = order === 'desc' ? 'asc' : 'desc';
		} else {
			// By request from customers we need to change default sort order for deadline column
			this.selectedSortParams = {
				sortColumn: option,
				order: option.columnKey === 'deadline' ? 'asc' : 'desc',
			};
		}
		this.selectedSortParamsSubject.next(this.selectedSortParams);
	}

	sorting() {
		this.selectedSortParams.order =
			this.selectedSortParams.order === 'asc' ? 'desc' : 'asc';
		this.selectedSortParamsSubject.next(this.selectedSortParams);
	}

	clearSort() {
		this.selectedSortParams = {
			sortColumn: null,
			order: 'asc',
		};
		this.selectedSortParamsSubject.next(this.selectedSortParams);
		this.clearSort$.next();
	}

	destroySortColumns() {
		this.sortColumns = [];
		this.sortColumnsSubject.next(this.sortColumns);

		this.clearSort();
	}
}
